import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { TopTestimonialsSection } from './components/TopTestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { ProductReveal } from './components/ProductReveal';
// Performance: Lazy-load below-the-fold sections to reduce initial JS bundle
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const IsForYouSection = lazy(() => import('./components/IsForYouSection').then(m => ({
  default: m.IsForYouSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const UpsellSection = lazy(() => import('./components/UpsellSection').then(m => ({
  default: m.UpsellSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const CostOfNotHavingItSection = lazy(() => import('./components/CostOfNotHavingItSection').then(m => ({
  default: m.CostOfNotHavingItSection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const SectionFallback = () => <div className="min-h-[200px]" data-id="element-0" />;
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'es';
    document.title = 'PROTORRENDA 4-12 — Método de Entrenamiento para Ciclistas Amateurs';
    if (!document.querySelector('meta[name="description"]')) {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'PROTORRENDA 4-12 — El método de los 4 pilares para el ciclista amateur argentino. 6 tomos + 4 bonos. Sistema de entrenamiento progresivo para mejorar tu rendimiento en subidas, pelotón y resistencia.';
      document.head.appendChild(meta);
    }
    if (!document.querySelector('meta[name="viewport"]')) {
      const viewport = document.createElement('meta');
      viewport.name = 'viewport';
      viewport.content = 'width=device-width, initial-scale=1';
      document.head.appendChild(viewport);
    }
    // Defer Meta Pixel until idle to avoid blocking main thread
    const loadPixel = () => {
      const script = document.createElement('script');
      script.async = true;
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '904978025482552');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
    };
    let pixelTimer: ReturnType<typeof setTimeout> | null = null;
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixel, {
        timeout: 5000
      });
    } else {
      pixelTimer = setTimeout(loadPixel, 4000);
    }
    return () => {
      if (pixelTimer) clearTimeout(pixelTimer);
    };
  }, []);
  return <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-amber-500/30 selection:text-amber-200 scroll-smooth" data-id="element-1">
      <a href="#pricing" className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-amber-500 focus:text-slate-950 focus:px-4 focus:py-2 focus:rounded-lg focus:font-bold" data-id="element-2">
        Ir al contenido principal
      </a>
      <main className="flex flex-col w-full overflow-x-hidden" role="main" data-id="element-3">
        <HeroSection data-id="element-4" />
        <TopTestimonialsSection data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <ProductReveal data-id="element-7" />
        <Suspense fallback={<SectionFallback data-id="element-9" />} data-id="element-8">
          <TomosSection data-id="element-10" />
          <BonusSection data-id="element-11" />
          <IsForYouSection data-id="element-12" />
          <PricingSection data-id="element-13" />
          <UpsellSection data-id="element-14" />
          <TestimonialsSection data-id="element-15" />
          <GuaranteeSection data-id="element-16" />
          <FAQSection data-id="element-17" />
          <CostOfNotHavingItSection data-id="element-18" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-19">
        <Footer data-id="element-20" />
      </Suspense>
    </div>;
}